import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // The real scroller is the frame viewport, not the window
    // (body scroll is locked by design).
    const viewport = document.querySelector(".frame-viewport");
    if (viewport) {
      viewport.scrollTop = 0;
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [pathname]);

  return null;
}
